export default {
  title: {
    id: 'bo_sellers_customer_care_page_title',
    defaultMessage: 'Customer care',
  },
  tabsBarLabel: {
    id: 'bo_sellers_customer_care_tabs_bar',
    defaultMessage: 'Customer care tabs',
  },
  openTasksTabTitle: {
    id: 'bo_sellers_customer_care_open_tasks_tab_title',
    defaultMessage: 'Open tasks',
  },
  allRequestsTabTitle: {
    id: 'bo_sellers_customer_care_all_requests_tab_title',
    defaultMessage: 'All requests',
  },
  noAgentMessagesTitle: {
    id: 'bo_sellers_customer_care_onboarding_info_block_no_agent_messages_title',
    defaultMessage:
      'Great news! To save you time, agents won’t proactively send messages anymore.',
  },
}
